import {
  JobStatus,
  StoreRefSchema,
  JobTaskStatus,
  JobTaskListSchema,
} from "@augmodo/lebron-browser-client";

export interface Job {
  id: string;
  store: StoreRefSchema;
  status: JobStatus;
  created_at: string;
  testing?: boolean;
}
export const getStatusColor = (status: Job["status"]) => {
  switch (status) {
    case JobStatus.NEEDS_REVIEW:
      return "orange";
    case JobStatus.IN_PROGRESS:
      return "blue";
    case JobStatus.COMPLETED:
      return "green";
    default:
      return "gray";
  }
};

export const getStatusText = (status: Job["status"]) => {
  switch (status) {
    case JobStatus.NEEDS_REVIEW:
      return "Needs Review";
    case JobStatus.IN_PROGRESS:
      return "In Progress";
    case JobStatus.COMPLETED:
      return "Completed";
    default:
      return "Unknown";
  }
};

export const getTaskStatusColor = (status: JobTaskStatus) => {
  switch (status) {
    case JobTaskStatus.PENDING:
      return "orange";
    case JobTaskStatus.COMPLETED:
      return "green";
    case JobTaskStatus.SKIPPED:
      return "gray";
  }
};

export const getTaskStatusText = (status: JobTaskStatus) => {
  switch (status) {
    case JobTaskStatus.PENDING:
      return "Pending";
    case JobTaskStatus.COMPLETED:
      return "Completed";
    case JobTaskStatus.SKIPPED:
      return "Skipped";
  }
};

export const getCurrentTaskNumber = (
  jobTasks: JobTaskListSchema | undefined,
  taskId: string,
) => {
  if (!jobTasks || !taskId || !jobTasks.tasks?.length) {
    return {
      current: 0,
      total: 0,
    };
  }
  return {
    current: jobTasks.tasks?.findIndex((task) => task.id === taskId) + 1,
    total: jobTasks.tasks?.length,
  };
};

export const formatMoney = (cents: number) => {
  return `$${(cents / 100).toFixed(2)}`;
};
